const defaultField = "startEventDate";
export const getSortParam = (sortFields) => {
    return sortFields
        ? sortFields.map(sortField => ({ field: sortField }))
        : [{ field: defaultField }];
};
//# sourceMappingURL=getSortParam.js.map